import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { AsyncPipe, DatePipe, NgForOf, NgIf } from '@angular/common';
import { TuiButtonModule, TuiLoaderModule } from '@taiga-ui/core';
import { tuiIsFalsy, TuiLetModule } from '@taiga-ui/cdk';
import { TuiTableModule } from '@taiga-ui/addon-table';
import { map, Observable, share, startWith } from 'rxjs';
import { AlertService } from '@shared/services/alert.service';
import { SpecificationRepositoryService } from '@shared/services/specification-repository.service';
import { WINDOW } from '@shared/providers/window.provider';
import { Specification } from '../../../../types/specification';
import { InvoicesRouteNames } from '../../../../route-names';

@Component({
  selector: 'app-specifications-journal',
  standalone: true,
  imports: [
    AsyncPipe,
    DatePipe,
    NgForOf,
    NgIf,
    TuiButtonModule,
    TuiLetModule,
    TuiLoaderModule,
    TuiTableModule,
  ],
  templateUrl: './specifications-journal.component.html',
  styleUrl: './specifications-journal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecificationsJournalComponent {
  readonly request$ = this.specificationsService.getAll().pipe(share());

  readonly data$: Observable<Specification[]> = this.request$.pipe(
    startWith([]),
  );

  header: Array<{
    text: string;
    value: keyof Specification;
  }> = [
    {
      text: '',
      value: 'id',
    },
  ];

  columns = this.header.map(h => h.value);

  readonly loading$ = this.request$.pipe(map(tuiIsFalsy));

  constructor(
    private readonly specificationsService: SpecificationRepositoryService,
    private readonly alert: AlertService,
    @Inject(WINDOW) private readonly window: Window,
  ) {}

  openSpecification(id: Specification['id']) {
    this.window.open(
      InvoicesRouteNames.SPECIFICATION.concat(`/${id}`),
      '_blank',
    );
  }
}
